module.exports = __webpack_public_path__ + "img/Сертификат организации здравоохранения 2020.dbe58e35.jpg";